export default {
  API_VERSION :process.env.API_VERSION || '',
  APP_VERSION: process.env.APP_VERSION || '1.0.0',
  APP_BASE_URL: process.env.REACT_APP_BASE_URL || '/',
  MEDIA_ROOT: 'https://bixuange.oss-cn-shanghai.aliyuncs.com/static/video/',
  DEV: true,
}
